import React from "react";
import { Spin } from "antd";
import { useVCESvalidator } from "@companion-core/shared/app/Components/VCES/VCESvalidator/hooks/vcesValidator";
import "@companion-core/web/src/Assets/Styles/scss/vces.scss";

export const VCESvalidator = () => {
  useVCESvalidator();

  return (
    <div className="vces">
      <Spin spinning={true} />
    </div>
  );
};
